import React from "react";

const Conditional: React.FunctionComponent<{ when: boolean }> = ({
  when,
  children,
}) => <>{when && children}</>;

export default Conditional;
